<ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Yeni Kasa</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="form">
        <div class="mb-3">
            <label for="caseName">Kasa Adı</label>
          <div class="input-group">
            <input id="caseName" class="form-control" type="text" formControlName="caseName">
          </div>
        </div>
        <div class="mb-3">
          <label>Kasa Tipi</label>
          <div class="input-group">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="caseTypeCash" name="caseType" [value]="CaseType.Cash" [(ngModel)]="model.caseType" [ngModelOptions]="{standalone: true}" (ngModelChange)="caseTypeChanged()">
              <label class="form-check-label" for="caseTypeCash">Nakit</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="caseTypeBank" name="caseType" [value]="CaseType.Bank" [(ngModel)]="model.caseType" [ngModelOptions]="{standalone: true}" (ngModelChange)="caseTypeChanged()">
              <label class="form-check-label" for="caseTypeBank">Banka</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="caseTypePos" name="caseType" [value]="CaseType.Pos" [(ngModel)]="model.caseType" [ngModelOptions]="{standalone: true}" (ngModelChange)="caseTypeChanged()">
              <label class="form-check-label" for="caseTypePos">POS (Kredi Kartı)</label>
            </div>
          </div>
        </div>

        <!-- POS ayarları (banka, taksit, komisyon) kasaya değil terminale ait olduğu için
             ayrı uçtan yönetilir; kasa oluşturulduktan sonra tanımlanır. -->
        <div class="alert alert-info py-2" *ngIf="model.caseType === CaseType.Pos">
          <i class="fas fa-credit-card me-1"></i>
          Kasa oluşturulduktan sonra <strong>Kasa &gt; POS Ayarları</strong> ekranından bağlı bankayı,
          taksit seçeneklerini ve komisyon oranlarını tanımlayınız. Oranlar tanımlanmadan bu kasayla
          tahsilat yapılamaz.
        </div>

        <ng-container *ngIf="model.caseType === CaseType.Bank">
          <div class="mb-3">
            <label>Banka Hesabı Kaynağı</label>
            <div class="input-group">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="bankAccountModeNew" name="bankAccountMode" value="new" [(ngModel)]="bankAccountMode" [ngModelOptions]="{standalone: true}" (ngModelChange)="bankAccountModeChanged()">
                <label class="form-check-label" for="bankAccountModeNew">Yeni Banka Hesabı Ekle</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="bankAccountModeExisting" name="bankAccountMode" value="existing" [(ngModel)]="bankAccountMode" [ngModelOptions]="{standalone: true}" (ngModelChange)="bankAccountModeChanged()">
                <label class="form-check-label" for="bankAccountModeExisting">Mevcut Hesaplardan Seç</label>
              </div>
            </div>
          </div>

          <div class="mb-3" *ngIf="bankAccountMode === 'existing'">
            <label for="existingBankAccountId">Banka Hesabı <span class="text-danger">*</span></label>
            <div class="input-group">
              <select id="existingBankAccountId" class="form-control form-select" [(ngModel)]="model.existingBankAccountId" [ngModelOptions]="{standalone: true}">
                <option [ngValue]="undefined">...Banka Hesabı Seçiniz...</option>
                <option *ngFor="let item of existingBankAccounts" [ngValue]="+item.value">{{ item.text }}</option>
              </select>
            </div>
          </div>

          <ng-container *ngIf="bankAccountMode === 'new'">
            <div class="mb-3">
              <label for="bankId">Banka <span class="text-danger">*</span></label>
              <div class="input-group">
                <select id="bankId" class="form-control form-select" [(ngModel)]="model.bankId" [ngModelOptions]="{standalone: true}">
                  <option [ngValue]="undefined">...Banka Seçiniz...</option>
                  <option *ngFor="let item of banks" [ngValue]="+item.value">{{ item.text }}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="bankBranchCode">Şube Kodu</label>
                  <div class="input-group">
                    <input id="bankBranchCode" type="text" class="form-control" [(ngModel)]="model.bankBranchCode" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="bankBranchName">Şube Adı</label>
                  <div class="input-group">
                    <input id="bankBranchName" type="text" class="form-control" [(ngModel)]="model.bankBranchName" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label for="bankAccountNumber">Hesap No</label>
              <div class="input-group">
                <input id="bankAccountNumber" type="text" class="form-control" [(ngModel)]="model.bankAccountNumber" [ngModelOptions]="{standalone: true}">
              </div>
            </div>
            <div class="mb-3">
              <label for="bankAccountIban">Iban</label>
              <div class="input-group">
                <input id="bankAccountIban" type="text" class="form-control" placeholder="TR..." [(ngModel)]="model.bankAccountIban" [ngModelOptions]="{standalone: true}">
              </div>
            </div>
            <div class="mb-3">
              <label for="bankAccountCurrencyCode">Para Birimi <span class="text-danger">*</span></label>
              <div class="input-group">
                <select id="bankAccountCurrencyCode" class="form-control form-select" [(ngModel)]="model.bankAccountCurrencyCode" [ngModelOptions]="{standalone: true}">
                  <option [ngValue]="undefined">...Para Birimi Seçiniz...</option>
                  <option *ngFor="let item of currencyCodes" [ngValue]="item">{{ item }}</option>
                </select>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="submit()">Kaydet</button>
      <button type="button" class="btn btn-secondary" (click)="modal.close('Save click')">Geri Dön</button>
    </div>
  </ng-template>


  <button class="btn btn-sm btn-primary" *hasRole="[Role.Admin, Role.SuperAdmin]" [disabled]="isDisabled" (click)="open(content)">
    <i class="fas fa-plus"></i> {{ presetExistingBankAccountId ? 'Kasa Oluştur' : 'Yeni Kasa' }}
  </button>
